import { Box, Button, IconButton } from "@mui/material";
import filtersStyles from "../SignRequestsFilters.styles";
import { CloseGlyph, LinkGlyph } from "./SignRequestsIcons";

const styles = filtersStyles;

interface SignRequestsSharedBannerProps {
  onSave: () => void;
  onDismiss: () => void;
}

/**
 * Shown while the applied filters arrived on the URL rather than from this
 * user: they are in force, but not one of their views until saved.
 */
const SignRequestsSharedBanner = ({
  onSave,
  onDismiss,
}: SignRequestsSharedBannerProps) => (
  <Box role="status" sx={styles.sharedBanner}>
    <LinkGlyph sx={styles.sharedBannerGlyph} />
    <Box component="span" sx={styles.sharedBannerText}>
      <b>Filters from a shared link.</b> They aren't saved to your views.
    </Box>
    <Button
      size="small"
      variant="outlined"
      onClick={onSave}
      sx={styles.sharedBannerAction}
    >
      Save as view
    </Button>
    <IconButton
      aria-label="Dismiss"
      onClick={onDismiss}
      sx={styles.sharedBannerDismiss}
    >
      <CloseGlyph sx={styles.sharedBannerDismissGlyph} />
    </IconButton>
  </Box>
);

export default SignRequestsSharedBanner;
